export default __webpack_public_path__ + "media/zurb/img/home/xurrent-rebrand-cd3710759d1b5bbb01f703d221b202a9.webp";